import { Image, StyleSheet, Text, View } from 'react-native'
import type { ImageSourcePropType } from 'react-native'

interface AvatarProps {
  accessibilityLabel?: string
  className?: string
  email?: string
  name?: string
  size?: number
  source?: ImageSourcePropType
}

export function Avatar({
  accessibilityLabel,
  className,
  email,
  name,
  size = 44,
  source,
}: AvatarProps) {
  const initial = getAvatarInitial(name, email)
  const radius = size / 2

  return (
    <View
      accessibilityLabel={accessibilityLabel}
      accessibilityRole={accessibilityLabel ? 'image' : undefined}
      className={`shrink-0 items-center justify-center overflow-hidden rounded-full border border-border bg-canvas-card ${className ?? ''}`}
      style={[
        styles.container,
        {
          borderRadius: radius,
          height: size,
          width: size,
        },
      ]}
    >
      {source ? (
        <Image source={source} resizeMode="cover" style={styles.image} />
      ) : (
        <Text className="font-semibold text-primary" style={{ fontSize: Math.max(12, size * 0.36) }}>
          {initial}
        </Text>
      )}
    </View>
  )
}

function getAvatarInitial(name?: string, email?: string) {
  const nameParts = name?.trim().split(/\s+/).filter(Boolean) ?? []

  if (nameParts.length >= 2) {
    return `${nameParts[0].slice(0, 1)}${nameParts[nameParts.length - 1].slice(0, 1)}`.toLocaleUpperCase()
  }

  const source = nameParts[0] || email?.trim() || '?'
  return source.slice(0, 1).toLocaleUpperCase()
}

const styles = StyleSheet.create({
  container: {
    flexShrink: 0,
  },
  image: {
    height: '100%',
    width: '100%',
  },
})
